import { TextInput } from "@msuite/ui/form";
import { type AsyncModalController, ConfirmModal } from "@msuite/ui/modal";
import { useForm, useWatch } from "react-hook-form";
import { MERGE_CONFIRM_VALUE } from "./shared";

/** Props Interface */
interface MergeProjectConfirmModalProps {
	controller: AsyncModalController<string>;
}

export function MergeProjectConfirmModal({ controller }: MergeProjectConfirmModalProps) {
	/** Render */
	const methods = useForm({
		defaultValues: {
			confirm: "",
		},
	});
	const currentConfirmValue = useWatch({ control: methods.control, name: "confirm" });

	/** Render */
	return (
		<ConfirmModal
			controller={controller}
			message={null}
			confirmIsDisabled={currentConfirmValue !== MERGE_CONFIRM_VALUE}
			onResolve={() => {
				const value = methods.getValues("confirm");
				methods.reset();
				return value;
			}}
			data-cy="merge-project-confirm-modal"
		>
			<TextInput
				control={methods.control}
				name="confirm"
				label="Confirm"
				placeholder={MERGE_CONFIRM_VALUE}
				helperText={`Type "${MERGE_CONFIRM_VALUE}" to confirm`}
				isRequired
				data-cy="merge-project-confirm-input"
			/>
		</ConfirmModal>
	);
}
